var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiLevelApproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.03125C11.3807 3.03125 12.5 4.15054 12.5 5.53125C12.5 6.91196 11.3807 8.03125 10 8.03125C8.61929 8.03125 7.5 6.91196 7.5 5.53125C7.5 4.15054 8.61929 3.03125 10 3.03125Z",
    stroke: "#67768E",
    strokeWidth: 1.14731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.0312C6.38071 13.0312 7.5 14.1505 7.5 15.5312C7.5 16.912 6.38071 18.0312 5 18.0312C3.61929 18.0312 2.5 16.912 2.5 15.5312C2.5 14.1505 3.61929 13.0312 5 13.0312Z",
    stroke: "#67768E",
    strokeWidth: 1.14731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.0312C16.3807 13.0312 17.5 14.1505 17.5 15.5312C17.5 16.912 16.3807 18.0312 15 18.0312C13.6193 18.0312 12.5 16.912 12.5 15.5312C12.5 14.1505 13.6193 13.0312 15 13.0312Z",
    stroke: "#67768E",
    strokeWidth: 1.14731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.0312V11.3646C15 10.8646 14.6667 10.5313 14.1667 10.5313H5.83333C5.33333 10.5313 5 10.8646 5 11.3646V13.0312",
    stroke: "#67768E",
    strokeWidth: 1.14731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5312V8.03125",
    stroke: "#67768E",
    strokeWidth: 1.14731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLevelApproval);
export default __webpack_public_path__ + "static/media/MultiLevelApproval.902815d6a5fd9da5cf9564e5990dda2c.svg";
export { ForwardRef as ReactComponent };